/**
 * @prettier
 */
import { cdn } from "acng/core/service/backend.js";
import { WEBLOG_DATA } from '../model/weblog-data.js';
import { guard } from '@acng/frontend-rubicon';
import { getLocale } from '../../locale/model/locale.js';
import escape from 'underscore/modules/escape.js';
import { media } from '../../core/service/env.js';


/**
 * Load a weblog entry by its id.
 * @param {Number} id 
 * @returns 
 */
export const weblogEntry = async (id) => {
  const data = await cdn(`amateur-profile/weblog/${id}?locale=${getLocale()}`);
  ASSERT: guard(data, WEBLOG_DATA, 'cdn response with weblog entry');
  data.content = escape(data.content).replace(/\[link\](.*)\[\/link\]/, (m, a) => {
    return `<span class="ons-item link"><span class="box"><span class="label">${a}</span></span></span>`;
  });
  if (data.image) {
    data.image = `${media.content.pictures}${data.image}`;
  } else {
    data.image = '';
  }
  data.published = new Date(data.published).toLocaleDateString(getLocale());
  return data;
}